export default {
  install: (Vue) => {
    Vue.prototype.$basketQuantity = function (bag) {
      return Object.values(bag).filter((bagItem) => bagItem.quantity > 0)
        .length;
    };
  },
};
